if (!customElements.get("main-product")) {
  class MainProduct extends HTMLElement {
    constructor() {
      super();
      this.quantityElement = document.querySelector('input[name="quantity"]');
      this.inputIdElement = document.getElementById('variant_input_id');
      if (this.quantityElement) this.quantityElement.addEventListener('change', this.updateQuantity.bind(this));
      this.getVariants();
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has('variant')) {
        const variantId = urlParams.get('variant');
        this.inputIdElement.value = variantId;
        this.inputIdElement.dispatchEvent(new Event("change", {
          bubbles: true
        }));
      }
    }
    getVariants() {
      this.variants = this.variants || JSON.parse(this.querySelector('[type="application/json"]')?.textContent || '[]');
      return this.variants;
    }
    updateQuantity(e) {
      // The resident controller calculates doll and accessory totals together.
      if (this.querySelector('resident-wardrobe')?.initialized) return;
      this.quantityElement = document.querySelector('input[name="quantity"]');
      const id = this.inputIdElement?.value || '';
      const quantity = e.target.value;
      const variant = this.variants.find(v => v.id == id);
      const subTotal = document.querySelector('.product-form__submit.btn-add-to-cart .product-sub-total');
      if (subTotal && variant) {
        const formatPrice = ShopifyUtility.formatPrice(variant.price * quantity, window.theme.moneyFormat);
        subTotal.textContent = formatPrice;
      }
    }
  }
  ;
  customElements.define("main-product", MainProduct);
}
;
if (!customElements.get("products-thumbnail-slider")) {
  customElements.define("products-thumbnail-slider", class ProductsThumbnailSlider extends SliderComponent {
    constructor() {
      super();
      this.position = this.slider?.getAttribute("data-media-position") || "1";
      this.navigation = this.slider?.getAttribute("data-navigation") || "none";
      this.sliderDirection = this.slider?.getAttribute("data-direction") || "vertical";
      this.sliderItemsToShow.forEach(item => item.addEventListener("click", this.onClickItem.bind(this)));
    }
    onClickItem(e) {
      const clientWidth = Math.round(document.body.clientWidth);
      if (this.navigation == "arrows" && clientWidth > 750) return;
      const target = e.target.closest(".thumbnail-list__item");
      const targetPosition = target?.getAttribute("data-media-position") || "1";
      this.position = this.slider?.getAttribute("data-media-position") || "1";
      let direction = "right";
      if (Number(this.position) > Number(targetPosition)) {
        direction = "left";
      }
      if (direction == "right") {
        if (this.sliderDirection == "vertical") {
          this.slider.scrollTo({
            left: target.offsetLeft,
            behavior: "smooth"
          });
        } else {
          this.slider.scrollTo({
            top: target.offsetTop,
            behavior: "smooth"
          });
        }
      } else {
        const previousSibling = target.previousSibling;
        if (this.sliderDirection == "vertical") {
          this.slider.scrollTo({
            left: previousSibling?.offsetLeft || 0,
            behavior: "smooth"
          });
        } else {
          this.slider.scrollTo({
            top: previousSibling?.offsetTop || 0,
            behavior: "smooth"
          });
        }
      }
      this.slider.setAttribute("data-media-position", targetPosition);
    }
  });
}
if (!customElements.get("product-modal")) {
  customElements.define("product-modal", class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.productModalContent = this.querySelector(".product-media-modal__content");
      this.productModalContent?.addEventListener("click", this.hide.bind(this));
    }
    hide() {
      super.hide();
    }
    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }
    showActiveMedia() {
      const dataMediaID = this.openedBy.getAttribute("data-media-id");
      const mediaList = this.productModalContent.querySelectorAll(".media, .deferred-media");
      const isDevice = adjustLayoutForDevice();
      for (let index = 0; index < mediaList.length; index++) {
        const media = mediaList[index];
        const currentMediaID = media.getAttribute("data-media-id");
        if (currentMediaID == dataMediaID) {
          media.classList.add("active");
        } else {
          media.classList.remove("active");
        }
      }
      if (isDevice == 'mobile') {
        const currentMedia = this.productModalContent.querySelector(`[data-media-id="${dataMediaID}"]`);
        if (!currentMedia) return;
        const image = currentMedia.querySelector('img');
        const centerX = (image.width - currentMedia.clientWidth) / 2;
        const centerY = (image.height - currentMedia.clientHeight) / 2;
        currentMedia.scrollTo({
          left: centerX,
          top: centerY,
          behavior: 'smooth'
        });
      }
    }
  });
}
if (!customElements.get("product-pagination-thumbnail")) {
  customElements.define("product-pagination-thumbnail", class ProductPaginationThumbnail extends Pagination {
    constructor() {
      super();
    }
    handlevent(item) {
      super.handlevent(item);
      const page = item.getAttribute("data-page");
      this.start = Number(page);
      const productSlider = document.querySelector(".main-media-slider .slider");
      if (productSlider) {
        const sliderItems = productSlider.querySelectorAll(".product__media-item");
        const slideScrollPosition = (Number(page) - 1) * (sliderItems.length > 0 ? sliderItems[0].clientWidth : 0);
        productSlider.scrollTo({
          left: slideScrollPosition,
          behavior: "smooth"
        });
      }
      const productCounter = document.querySelector(".mobile-product-counter");
      if (productCounter) {
        productCounter.innerHTML = `${this.start}/${this.totalPages}`;
      }
    }
  });
}
if (!customElements.get("product-description")) {
  customElements.define("product-description", class ProductDescription extends HTMLElement {
    constructor() {
      super();
      this.productDescriptionReveal = this.querySelector(".product__description-reveal");
      this.productDescriptionContent = this.querySelector(".product__description-content");
      this.productDescriptionReadmore = this.querySelector(".product__description-read-more");
      if (this.productDescriptionReadmore && this.productDescriptionContent && this.productDescriptionContent.clientHeight > 90) {
        this.productDescriptionReadmore.style.display = "block";
        this.productDescriptionContent.style.height = "90px";
        this.productDescriptionContent.classList.add('text-mask-image');
        this.productDescriptionReadmore.addEventListener("click", this.clickReadmore.bind(this));
      }
    }
    clickReadmore() {
      if (this.productDescriptionReadmore && this.productDescriptionContent) {
        this.productDescriptionReadmore.style.display = "none";
        this.productDescriptionContent.style.height = "auto";
        this.productDescriptionContent.classList.remove('text-mask-image');
      }
    }
  });
}
if (!customElements.get("variant-selects")) {
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      const self = this;
      this.labels = this.querySelectorAll(".product-form__input label");
      this.addEventListener("change", this.onVariantChange);
      this.variantSelector = this.querySelector(".variant-selector");
      this.querySelectorAll("insp-dropdown").forEach(dropdown => {
        dropdown.addEventListener("itemChangedData", function (data) {
          self.onVariantChange();
        });
      });
      for (let index = 0; index < this.labels.length; index++) {
        const label = this.labels[index];
        this.updateDiagonal(label);
      }
      window.addEventListener('resize', () => {
        for (let index = 0; index < this.labels.length; index++) {
          const label = this.labels[index];
          this.updateDiagonal(label);
        }
      });

      // Listen for quantity changes to update error message
      const quantityInput = document.querySelector('input[name="quantity"]');
      if (quantityInput) {
        quantityInput.addEventListener('change', () => {
          this.updateErrorMessage();
        });
        quantityInput.addEventListener('input', () => {
          this.updateErrorMessage();
        });
      }

      //FIRST LOAD
      this.updateOptions();
      this.updateMasterId();
      this.updateErrorMessage();
      this.checkAddToCartButton();
      this.updateMedia();
    }
    updateDiagonal(label) {
      const boxWidth = label.offsetWidth;
      const boxHeight = label.offsetHeight;
      const diagonalLength = Math.sqrt(Math.pow(boxWidth, 2) + Math.pow(boxHeight, 2)) - 3;
      const toDegrees = radians => Math.floor(radians * (180 / Math.PI)).toFixed(0);
      const theta2 = toDegrees(Math.asin(boxHeight / diagonalLength));
      label.style.setProperty("--diagonal-angle", `rotate(-${theta2}deg)`);
      label.style.setProperty("--diagonal-length", Math.floor(diagonalLength).toFixed(0) + "px");
    }
    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();

      // Reset quantity to 1 when variant changes
      const quantityInput = document.querySelector('input[name="quantity"]');
      if (quantityInput && quantityInput.value != 1) {
        quantityInput.value = 1;
        quantityInput.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      }
      this.updateErrorMessage();
      this.checkAddToCartButton();
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVendor();
      this.updateStickyAddToCartData();
      if (!this.currentVariant) {
        this.setUnavailable();
      } else {
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
        this.updateInventoryStatus();
      }
    }
    updateOptions() {
      this.options = Array.from(this.querySelectorAll(".variant-selector"), select => select.getAttribute("data-value") || "");
      const variants = JSON.parse(this.querySelector('[type="application/json"]').textContent) || [];
      this.querySelectorAll(".variant-selector").forEach((selection, index1) => {
        selection.querySelectorAll(".selector-item").forEach(option => {
          var thisValue = option.getAttribute("data-value");
          var thisOptions = [];
          this.options.forEach((item, index) => {
            if (index == index1) {
              thisOptions[index] = thisValue;
            } else {
              thisOptions[index] = this.options[index];
            }
            var matchedVariant = variants.find(variant => {
              return !variant.options.map((option, index) => {
                return thisOptions[index] === option;
              }).includes(false);
            });
            if (matchedVariant && matchedVariant.available) {
              option.classList.remove('disabled');
            } else {
              option.classList.add('disabled');
            }
          });
        });
      });
    }
    updateMasterId() {
      const variantData = this.getVariantData();
      if (!variantData) return;
      this.currentVariant = variantData.find(variant => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }
    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
      const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
      if (mediaGallery) {
        mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
      }
      const quickAddContainer = this.closest('.product')?.querySelector('.product-image-on-quick-add');
      if (quickAddContainer) {
        const mediaId = this.currentVariant.featured_media.id;
        const quickAddSlider = quickAddContainer.querySelector('slider-component.quick-add-media-slider');
        if (quickAddSlider) {
          quickAddSlider.querySelectorAll('.quick-add-media-item').forEach((slide, index) => {
            if (slide.dataset.quickAddMediaId == mediaId) {
              quickAddSlider.currentPage = index + 1;
              if (typeof quickAddSlider.goToSlide === 'function') quickAddSlider.goToSlide();
            }
          });
        } else {
          quickAddContainer.querySelectorAll('.quick-add-media-item').forEach(item => {
            if (item.dataset.quickAddMediaId == mediaId) {
              item.classList.remove('hidden');
            } else {
              item.classList.add('hidden');
            }
          });
        }
      }
      const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
      if (!modalContent) return;
      const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
      if (newMediaModal) modalContent.prepend(newMediaModal);
    }
    updateURL() {
      const updateUrl = this.dataset.updateUrl || this.getAttribute("data-update-url");
      if (!this.currentVariant || updateUrl === "false") return;
      window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
    updateVariantInput() {
      const sectionId = this.dataset.section || this.getAttribute("data-section");
      const productForms = document.querySelectorAll(`#product-form-${sectionId}, #product-form-installment`);
      const hiddenInputId = this.closest(".product").querySelector('form[data-type="add-to-cart-form"]').querySelector('input[name="id"]');
      const featuredProductUrl = this.closest(".product").querySelector(".featured-product-url");
      if (featuredProductUrl) {
        const variantURL = `${this.dataset.url}?variant=${this.currentVariant.id}`;
        featuredProductUrl.href = variantURL;
      }
      if (hiddenInputId) hiddenInputId.value = this.currentVariant.id;
      productForms.forEach(productForm => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event("change", {
          bubbles: true
        }));
      });
    }
    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector("pickup-availability");
      if (!pickUpAvailability) return;
      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute("available");
        pickUpAvailability.innerHTML = "";
      }
    }
    removeErrorMessage() {
      const section = this.closest("section");
      if (!section) return;
      const productForm = section.querySelector("product-form");
      if (productForm) productForm.handleErrorMessage();
    }
    renderProductInfo() {
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`).then(response => response.text()).then(responseText => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        if (source && destination) destination.innerHTML = source.innerHTML;
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove("visibility-hidden");
        const stickyid = `sticky-price-${this.dataset.section}`;
        const stickyhtml = new DOMParser().parseFromString(responseText, "text/html");
        const stickydestination = document.getElementById(stickyid);
        const stickysource = html.getElementById(stickyid);
        if (stickysource && stickydestination) stickydestination.innerHTML = stickysource.innerHTML;
        const stickyprice = document.getElementById(`sticky-price-${this.dataset.section}`);
        if (stickyprice) stickyprice.classList.remove("visibility-hidden");
        const product__inventory_status_id = `product__inventory_status-${this.dataset.section}`;
        const product__inventory_status_destination = document.getElementById(product__inventory_status_id);
        const product__inventory_status_source = html.getElementById(product__inventory_status_id);
        if (product__inventory_status_source && product__inventory_status_destination) product__inventory_status_destination.innerHTML = product__inventory_status_source.innerHTML;
      });
    }
    toggleAddButton(disable = true, text, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
      if (!addButton) return;
      if (disable) {
        addButton.setAttribute("disabled", "disabled");
        if (text && addButtonText) addButtonText.textContent = text;
        if (addButton.parentElement.classList.contains("product-form__buttons-wrapper")) addButton.parentElement.classList.add("disabled");
      } else {
        addButton.removeAttribute("disabled");
        if (addButtonText) addButtonText.textContent = window.variantStrings.addToCart;
        if (addButton.parentElement.classList.contains("product-form__buttons-wrapper")) addButton.parentElement.classList.remove("disabled");
      }
      const stickyAddButton = document.querySelector(".sticky-product-form__submit");
      if (stickyAddButton) {
        if (disable) {
          stickyAddButton.removeAttribute("disabled", "disabled");
          stickyAddButton.classList.add("disabled");
          if (text) stickyAddButton.textContent = text;
        } else {
          stickyAddButton.removeAttribute("disabled");
          stickyAddButton.classList.remove("disabled");
          stickyAddButton.textContent = window.variantStrings.addToCart;
        }
      }
      if (!modifyClass) return;
    }
    setUnavailable() {
      const button = document.getElementById(`product-form-${this.dataset.section}`);
      const addButton = button?.querySelector('[name="add"]');
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (!addButton) return;
      const unavailableText = window.variantStrings?.unavailable || 'Unavailable';

      // Show the "unavailable" message on the .sold-out-label rather than writing
      // textContent onto the button's wrapper span ([name="add"] > span). The
      // wrapper holds the .add-to-cart-label / .sold-out-label / .product-sub-total
      // spans, and overwriting its textContent used to delete them — so when a valid
      // variant was reselected, checkAddToCartButton() could not relabel the button
      // (its .add-to-cart-label query returned null) and it stayed "Unavailable".
      // Keeping the spans intact lets checkAddToCartButton() restore the label.
      const addLabel = addButton.querySelector('.add-to-cart-label');
      const soldOutLabel = addButton.querySelector('.sold-out-label');
      const subTotal = addButton.querySelector('.product-sub-total');
      if (soldOutLabel) {
        soldOutLabel.textContent = unavailableText;
        soldOutLabel.classList.remove('hidden');
        if (addLabel) addLabel.classList.add('hidden');
      } else if (addLabel) {
        addLabel.textContent = unavailableText;
      }
      if (subTotal) subTotal.textContent = '';
      addButton.setAttribute("disabled", "disabled");
      addButton.classList.add("disabled");
      if (price) price.classList.add('visibility-hidden');
      const stickyPrice = document.getElementById(`sticky-price-${this.dataset.section}`);
      if (stickyPrice) stickyPrice.classList.add('visibility-hidden');
      const soldOutBadge = price?.querySelector('.badge__sold-out');
      if (soldOutBadge) {
        soldOutBadge.textContent = unavailableText;
      }
    }
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
    checkAddToCartButton() {
      if (!this.currentVariant) return;
      const btnAddToCart = this.closest('.product__info-wrapper').querySelector(".btn-add-to-cart");
      const btnNotifyStock = this.closest('.product__info-wrapper').querySelector(".btn-modal-notify-stock");
      const btnBuyItnow = this.closest('.product__info-wrapper').querySelectorAll('.shopify-payment-button, .btn-buy-itnow, .shopify-payment-button__button');
      const showNotifyStock = btnAddToCart?.getAttribute("data-show-notify-stock");
      if (this.currentVariant.available) {
        const addButtonText = btnAddToCart?.querySelector('.add-to-cart-label');
        if (addButtonText) {
          addButtonText.textContent = window.variantStrings.addToCart || 'Add to cart';
        }

        // Remove BOTH attribute AND class
        btnAddToCart?.removeAttribute("disabled");
        btnAddToCart?.classList.remove("disabled");
        btnAddToCart?.classList.remove("hidden");
        btnNotifyStock?.classList.add("hidden");
        btnAddToCart?.querySelector(".add-to-cart-label")?.classList?.remove("hidden");
        btnAddToCart?.querySelector(".sold-out-label")?.classList?.add("hidden");
        btnBuyItnow.forEach(element => {
          element.removeAttribute("disabled");
          element.classList.remove("hidden");
        });
        const subTotal = btnAddToCart?.querySelector('.product-sub-total');
        if (subTotal) {
          const quantity = document.querySelector('input[name="quantity"]')?.value || 1;
          const formatPrice = ShopifyUtility.formatPrice(this.currentVariant.price * quantity, window.theme.moneyFormat);
          subTotal.textContent = formatPrice;
        }
      } else {
        const addButtonText = btnAddToCart?.querySelector('.sold-out-label');
        if (addButtonText) {
          addButtonText.textContent = window.variantStrings.soldOut || 'Sold out';
        }

        // Add BOTH attribute AND class
        btnAddToCart?.setAttribute("disabled", "disabled");
        btnAddToCart?.classList.add("disabled");
        if (showNotifyStock == "true") {
          btnAddToCart?.classList.add("hidden");
        }
        btnAddToCart?.querySelector(".add-to-cart-label")?.classList?.add("hidden");
        btnAddToCart?.querySelector(".sold-out-label")?.classList?.remove("hidden");
        btnNotifyStock?.classList.remove("hidden");
        btnBuyItnow.forEach(btn => {
          btn.setAttribute("disabled", "");
          btn.classList.add("hidden");
        });
      }
    }

    // Dynamic error message update
    updateErrorMessage() {
      const errorWrapper = this.closest('.product__info-wrapper')?.querySelector('.product-form__error-message-wrapper') || this.closest('section')?.querySelector('.product-form__error-message-wrapper');
      if (!errorWrapper) return;
      const errorMessage = errorWrapper.querySelector('.product-form__error-message');

      // Always clear first to prevent stale messages
      errorWrapper.classList.add('hidden');
      errorWrapper.classList.remove('flex');
      if (errorMessage) errorMessage.textContent = '';

      // Show error if no matching variant exists
      if (!this.currentVariant) {
        const selectedOptions = this.options.filter(opt => opt).join(' / ');
        const productTitle = document.querySelector('.product__title')?.textContent?.trim() || 'This product';
        const errorText = `The product '${productTitle} - ${selectedOptions}' is unavailable.`;
        if (errorMessage) {
          errorMessage.textContent = errorText;
        }
        errorWrapper.classList.remove('hidden');
        errorWrapper.classList.add('flex');
        return;
      }

      // Show error if variant is sold out
      if (this.currentVariant && !this.currentVariant.available) {
        const productTitle = document.querySelector('.product__title')?.textContent?.trim() || 'This product';
        const variantTitle = this.currentVariant.title;
        const errorText = `The product '${productTitle} - ${variantTitle}' is already sold out.`;
        if (errorMessage) {
          errorMessage.textContent = errorText;
        }
        errorWrapper.classList.remove('hidden');
        errorWrapper.classList.add('flex');
        return;
      }

      // Check for low inventory warning (quantity exceeds stock)
      if (this.currentVariant && this.currentVariant.available) {
        const quantityInput = document.querySelector('input[name="quantity"]');
        const requestedQty = quantityInput ? parseInt(quantityInput.value) : 1;
        const inventoryElement = document.getElementById(`product-variant-${this.currentVariant.id}`);
        const availableQty = inventoryElement ? parseInt(inventoryElement.innerHTML) : 999;
        if (requestedQty > availableQty && availableQty > 0) {
          const productTitle = document.querySelector('.product__title')?.textContent?.trim() || 'This product';
          const variantTitle = this.currentVariant.title;
          const errorText = `The product '${productTitle} - ${variantTitle}' only has ${availableQty} in stock. Please adjust your quantity.`;
          if (errorMessage) {
            errorMessage.textContent = errorText;
          }
          errorWrapper.classList.remove('hidden');
          errorWrapper.classList.add('flex');
          return;
        }
      }
    }
    updateInventoryStatus() {
      if (!this.currentVariant) return;
      const productInventoryStatus = this.closest(".product__info-container").querySelector("product-inventory-status");
      if (productInventoryStatus) {
        const lowIntentoryThreshold = productInventoryStatus.dataset.lowIntentoryThreshold * 1;
        const inventoryQuantity = (document.getElementById(`product-variant-${this.currentVariant.id}`)?.innerHTML || "0") * 1;
        if (!this.currentVariant.available || inventoryQuantity > lowIntentoryThreshold) {
          productInventoryStatus.classList.add('hidden');
          productInventoryStatus.classList.remove('block');
          return;
        } else {
          productInventoryStatus.classList.add('block');
          productInventoryStatus.classList.remove('hidden');
        }
        productInventoryStatus.inventoryQuantity = inventoryQuantity;
        productInventoryStatus.updateInventoryStatusLabel(inventoryQuantity);
        productInventoryStatus.updateInventoryProgress(inventoryQuantity);
      }
    }
    updateVendor() {
      if (!this.currentVariant) return;
      const skuEle = this.closest(".product__info-container").querySelector(".product__vendor-sku");
      if (skuEle) skuEle.innerHTML = `${window.variantStrings?.skuLabel || 'SKU:'} ${this.currentVariant.sku}`;
    }
    updateStickyAddToCartData() {
      if (!this.currentVariant) return;
      const stickyAddToCartElement = document.querySelector("product-sticky-add-to-cart");
      if (stickyAddToCartElement) {
        stickyAddToCartElement.setVariantId(this.currentVariant.id);
        setTimeout(() => {
          stickyAddToCartElement.setPrice(this.currentVariant.price, this.currentVariant.compare_at_price);
        }, 300);
        if (this.currentVariant.available == false) {
          stickyAddToCartElement.addToCartButton.disabled = true;
          stickyAddToCartElement.addToCartButton.innerHTML = window.variantStrings?.soldOut || "Sold out";
        } else {
          stickyAddToCartElement.addToCartButton.disabled = false;
          stickyAddToCartElement.addToCartButton.innerHTML = window.variantStrings?.addToCart || "Add to cart";
        }
      }
    }
  }
  customElements.define("variant-selects", VariantSelects);
  if (!customElements.get("variant-radios")) {
    customElements.define("variant-radios", class VariantRadios extends VariantSelects {
      constructor() {
        super();
      }
      updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll("fieldset"));
        this.options = fieldsets.map(fieldset => {
          return Array.from(fieldset.querySelectorAll("input")).find(radio => radio.checked)?.value;
        });
        const currentOptions = this.options;
        this.querySelectorAll("fieldset").forEach(function (selection, index1) {
          selection.querySelectorAll("input").forEach(function (option, index2) {
            var thisValue = option.value;
            var thisOptions = [];
            currentOptions.forEach(function (item, index) {
              if (index == index1) {
                thisOptions[index] = thisValue;
              } else {
                thisOptions[index] = currentOptions[index];
              }
            });
            var matchedVariant = JSON.parse(selection.closest("variant-radios").querySelector('[type="application/json"]').textContent).find(variant => {
              return !variant.options.map((option, index) => {
                return thisOptions[index] === option;
              }).includes(false);
            });
            if (matchedVariant && matchedVariant.available) {
              option.classList.remove("disabled");
            } else {
              option.classList.add("disabled");
            }
          });
        });
      }
    });
  }
}
if (!customElements.get("product-inventory-status")) {
  customElements.define("product-inventory-status", class ProductInventoryStatus extends HTMLElement {
    constructor() {
      super();
      this.lowInventoryThreshold = this.getAttribute("data-low-intentory-threshold");
      this.inventoryQuantity = this.getAttribute("data-inventory-quantity") ? this.getAttribute("data-inventory-quantity").trim() : 0;
      this.inventoryStatusLabel = this.querySelector(".product__inventory_status-title");
      this.inventoryProgressBar = this.querySelector(".progress-bar__container .progress-bar");
      this.updateInventoryStatusLabel();
    }
    updateInventoryStatusLabel(quantity) {
      const value = quantity || this.inventoryQuantity;
      const threshold = (this.dataset.lowIntentoryThreshold || this.getAttribute('data-low-intentory-threshold')) * 1;
      this.dataset.inventoryQuantity = value;
      if (this.inventoryStatusLabel) {
        if (this.inventoryStatusLabel.querySelector(".inventory_quantity")) {
          this.inventoryStatusLabel.querySelector(".inventory_quantity").innerHTML = value;
        } else if (this.inventoryStatusLabel.innerHTML.includes("||count||")) {
          this.inventoryStatusLabel.innerHTML = this.inventoryStatusLabel.innerHTML.replace("||count||", `<span class="inventory_quantity">${value}</span>`);
        }
      }
    }
    updateInventoryProgress(quantity) {
      const value = quantity || this.inventoryQuantity || 0;
      if (!this.inventoryProgressBar) return;
      const progress = Math.round(value * 1 * 100 / (this.lowInventoryThreshold * 1));
      this.inventoryProgressBar.style.setProperty("--progress-bar-progress", `${progress > 100 ? 100 : progress}%`);
    }
  });
}
if (!customElements.get("product-sticky-add-to-cart")) {
  customElements.define("product-sticky-add-to-cart", class ProductStickyAddToCart extends HTMLElement {
    constructor() {
      super();
      const self = this;
      this.productFormButtons = document.querySelector(".product-form__buttons");
      this.inputVariantId = document.getElementById("sticky-form-add-to-cart")?.querySelector('input[name="id"]');
      this.inputQuantity = document.getElementById("sticky-form-add-to-cart")?.querySelector('input[name="quantity"]');
      this.addToCartButton = this.querySelector(".sticky-add-to-cart-button");
      this.stickyAddToCartPrice = this.querySelector(".product-sticky-add-to-cart-price");
      this.quntityInput = document.querySelector(".product-form__buttons quantity-input");
      this.addToCartButton.addEventListener("click", this.clickAddToCart.bind(this));
      if (this.quntityInput) this.quntityInput.input.addEventListener("change", function () {
        self.setQuantity(this.value);
      });
      window.addEventListener("scroll", () => {
        if (!this.productFormButtons) return;
        self.show = self.getAttribute("data-show");
        const clientWidth = Math.round(document.body.clientWidth);
        var productFormButtonsTop = self.productFormButtons.getBoundingClientRect().top;
        if (self.show == "show_on_desktop_only" && clientWidth > 750 || self.show == "show_on_mobile_only" && clientWidth <= 749 || self.show == "show_all_devices") {
          self.toggleVisibility(productFormButtonsTop);
        }
      });
    }
    clickAddToCart() {
      const productContainer = document.querySelector(".product__info-wrapper");
      if (productContainer) productContainer.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
    toggleVisibility(position) {
      if (position < 0) {
        this.classList.remove("hidden");
      } else {
        this.classList.add("hidden");
      }
    }
    setVariantId(id) {
      if (this.inputVariantId) this.inputVariantId.value = id;
    }
    setQuantity(value) {
      if (this.inputQuantity) this.inputQuantity.value = value;
    }
    setPrice(price, compare_at_price) {}
  });
}
if (!customElements.get("product-stacked-popover")) {
  customElements.define("product-stacked-popover", class ProductStackedPopover extends HTMLElement {
    constructor() {
      super();
      this.popoverButton = this.querySelector(".product-stacked-popover-button");
      this.popoverContent = this.querySelector('.product-stacked-popover-content');
      window.addEventListener('resize', () => {
        this.init();
      });
      this.init();
    }
    isElementInViewport(el) {
      if (!el) return false;
      const rect = el.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom > 0 && rect.left < window.innerWidth && rect.right > 0;
    }
    init() {
      const clientWidth = Math.round(document.body.clientWidth);
      if (clientWidth > 749) return;
      window.addEventListener("scroll", this.onSCroll.bind(this));
      if (this.popoverButton) this.popoverButton.addEventListener("click", this.onClickButton.bind(this));
    }
    onSCroll(e) {
      const target = document.querySelector(".product__media-wrapper");
      const productTitleElement = document.querySelector('.product-block-title__wrapper .product__title');
      const productTitleInViewPort = this.isElementInViewport(productTitleElement);
      const productMediaInViewPort = this.isElementInViewport(target);
      if (!productTitleInViewPort && productMediaInViewPort) {
        this.popoverContent.classList.add('show');
      } else {
        this.popoverContent.classList.remove('show');
      }
    }
    onClickButton() {
      const element = document.getElementById('product__info-wrapper');
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  });
}

// Track active thumbnail for opacity
document.addEventListener('DOMContentLoaded', function () {
  const thumbnails = document.querySelectorAll('.thumbnail-list__item');

  // Set first thumbnail as active on load
  if (thumbnails.length > 0) {
    thumbnails[0].classList.add('js-active-thumbnail');
  }

  // Update active state on click
  thumbnails.forEach(thumb => {
    thumb.addEventListener('click', function () {
      // Remove active from all
      thumbnails.forEach(t => t.classList.remove('js-active-thumbnail'));
      // Add active to clicked
      this.classList.add('js-active-thumbnail');
    });
  });
});

// Sticky add to cart
if (!customElements.get('sticky-atc')) {
  class StickyAtc extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.button = this.querySelector('.sticky-atc__button');
      this.productSection = document.getElementById(`shopify-section-${this.sectionId}`);
    }
    connectedCallback() {
      if (!this.productSection) return;
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.classList.remove('is-visible');
            document.body.classList.remove('sticky-atc-visible');
          } else {
            this.classList.add('is-visible');
            document.body.classList.add('sticky-atc-visible');
          }
        });
      }, {
        threshold: 0
      });
      this.observer.observe(this.productSection);
      if (this.button) {
        this.button.addEventListener('click', this.scrollToProduct.bind(this));
      }
    }
    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
      document.body.classList.remove('sticky-atc-visible');
    }
    scrollToProduct() {
      if (this.productSection) {
        this.productSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  }
  customElements.define('sticky-atc', StickyAtc);
}
